export default "__VITE_PUBLIC_ASSET__7d3a38af__"